import { makeRequest } from "@kivra/sdk/common";
import type { Config } from "../types";

export function getConfig(): Promise<Config> {
  const configUrl = window.CONFIG_URL;
  if (!configUrl) {
    console.warn(
      "window.CONFIG_URL is missing. Will default to default config",
    );
  }
  return makeRequest({ method: "get", url: configUrl });
}
